import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import { ElementDefinition, RawElement } from "@easy-email-pro-core/typings";
import { BasicBlock } from "@easy-email-pro-core/components";
import React from "react";

const defaultData: ElementDefinition<RawElement>["defaultData"] = {
  attributes: {},
  data: { content: "" },
};

export const Raw = createBlock<RawElement>({
  get name() {
    return t("Raw");
  },
  defaultData,
  type: BasicType.RAW,
  create: (payload) => {
    const defaultData: RawElement = {
      type: BasicType.RAW,
      data: {
        content: "",
      },
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.RAW,
  render(params) {
    if (params.mode === "testing") {
      return (
        <BasicBlock
          tag={"span"}
          params={{
            ...params,
            node: {
              ...params.node,
              attributes: {
                "element-type": BasicType.RAW,
                "element-category": ElementCategory.RAW,
                "element-data": encodeURIComponent(
                  JSON.stringify(params.node.data)
                ),
              } as any,
            },
          }}
        />
      );
    }
    return (
      <BasicBlock params={params} tag="mj-raw">
        {params.node.data.content}
      </BasicBlock>
    );
  },
});
